export default __webpack_public_path__ + "static/store-one.en-d7521bb027be18ecdda249893e13e908.png";